
import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import EditProfile from '../components/EditProfile';
import './Profile.css';

const Profile = () => {
  const { user } = useUser();
  const [showSkillForm, setShowSkillForm] = useState(false);
  const [newSkill, setNewSkill] = useState('');
  const [showEditModal, setShowEditModal] = useState(false); // 控制模态框显示

  const handleAddSkill = (e) => {
    e.preventDefault();
    if (newSkill.trim()) {
      // 这里需要添加技能的逻辑
      setNewSkill('');
      setShowSkillForm(false);
    }
  };

  return (
    <>
      <div className="profile">
        <div className="profile-header">
          <div className="profile-avatar">
            <div className="avatar">
              {user.avatar ? (
                <img 
                  src={user.avatar}
                  alt="用户头像" 
                  className="avatar-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const nextSibling = e.target.nextElementSibling;
                    if (nextSibling) {
                      nextSibling.style.display = 'flex';
                    }
                  }}
                />
              ) : null}
              
              <div 
                className="avatar-circle" 
                style={{ 
                  display: user.avatar ? 'none' : 'flex',
                  backgroundColor: user.avatarColor || '#4a90e2'
                }}
              >
                {user.name ? user.name.charAt(0).toUpperCase() : '?'}
              </div>
            </div>
          </div>
          <div className="profile-info">
            <h1>Hi，我是 {user.name}！</h1>
            <p className="profile-bio">{user.bio}</p>
            <p className="profile-subtitle">探索我的博客，发现技术世界的精彩！</p>
          </div>
        </div>
        
        <div className="profile-actions">
          <button 
            className="edit-profile-btn"
            onClick={() => setShowEditModal(true)}
          >
            编辑个人信息
          </button>
        </div>
        
        <div className="profile-content">
          <div className="profile-section">
            <h2>个人信息</h2>
            <div className="info-grid">
              <div className="info-card">
                <div className="info-icon">📧</div>
                <div className="info-content">
                  <h3>邮箱</h3>
                  <p>{user.email}</p>
                </div>
              </div>
              
              <div className="info-card">
                <div className="info-icon">💼</div>
                <div className="info-content">
                  <h3>职位</h3>
                  <p>{user.position}</p>
                </div>
              </div>
              
              <div className="info-card">
                <div className="info-icon">📍</div>
                <div className="info-content">
                  <h3>位置</h3>
                  <p>{user.location}</p>
                </div>
              </div>
              
              <div className="info-card">
                <div className="info-icon">📅</div>
                <div className="info-content">
                  <h3>加入时间</h3>
                  <p>{user.joinDate}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="profile-section">
            <div className="section-header">
              <h2>技术栈</h2>
              <button 
                className="add-skill-btn"
                onClick={() => setShowSkillForm(!showSkillForm)}
              >
                {showSkillForm ? '取消' : '添加技能'}
              </button>
            </div>
            
            {showSkillForm && (
              <form className="skill-form" onSubmit={handleAddSkill}>
                <input
                  type="text"
                  value={newSkill}
                  onChange={(e) => setNewSkill(e.target.value)}
                  placeholder="输入新技能"
                  className="skill-input"
                />
                <button type="submit" className="skill-submit-btn">添加</button>
              </form>
            )}
            
            <div className="skills-container">
              {user.techStack.map((tech, index) => (
                <div key={index} className="skill-item">
                  <span className="skill-name">{tech.name}</span>
                  <div className="skill-bar">
                    <div 
                      className="skill-level" 
                      style={{ width: `${tech.level}%` }}
                    >
                      <span className="skill-level-text">{tech.level}%</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="profile-section">
            <h2>兴趣爱好</h2>
            <div className="interests-container">
              {Array.isArray(user.skills) ? (
                user.skills.map((skill, index) => (
                  <span key={index} className="interest-tag">{skill}</span>
                ))
              ) : (
                <span className="interest-tag">{user.skills}</span>
              )}
            </div>
          </div>
          
          <div className="profile-section">
            <h2>社交媒体</h2>
            <div className="social-links">
              <a href="#" className="social-link">GitHub</a>
              <a href="#" className="social-link">掘金</a>
              <a href="#" className="social-link">知乎</a>
              <a href="#" className="social-link">CSDN</a>
              <a href="#" className="social-link">微信公众号</a>
              <div className="social-custom">
                <span className="social-label">微博：</span>
                <span>{user.socialMedia}</span>
              </div>
            </div>
          </div>
          
          <div className="profile-section">
            <h2>博客统计</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-value">42</div>
                <div className="stat-label">发布文章</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">3,280</div>
                <div className="stat-label">总阅读量</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">156</div>
                <div className="stat-label">获得点赞</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">89</div>
                <div className="stat-label">评论数量</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">18</div>
                <div className="stat-label">文章分类</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">365</div>
                <div className="stat-label">创作天数</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="profile-footer">
          <p>© 2023 我的博客 All Rights Reserved.</p>
          <p className="footer-note">探索技术，分享知识，共同成长</p>
        </div>
      </div>

      {/* 灯箱模态框 */}
      {showEditModal && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <EditProfile 
              onClose={() => setShowEditModal(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;